import TaoEditor from "@/components/TaoEditor";
import { styled } from "@stitches/react";

const Wrapper = styled("div", {
    display: "flex",
    justifyContent: "center",
});

const TaoEditorContainer = () => {

    return (
        <Wrapper>
            <TaoEditor />
        </Wrapper>
    );
};

export default TaoEditorContainer;
